import React from 'react'
import { TaskCard, TaskColumn } from '../../types/task-board'

interface TaskCardPositionProps {
  card: TaskCard
  column: TaskColumn
  onChangePosition: (cardId: string, columnId: string, direction: 'up' | 'down') => Promise<void>
}

export const TaskCardPosition: React.FC<TaskCardPositionProps> = ({ card, column, onChangePosition }) => {
  const cardIndex = column.cards.findIndex(c => c.id === card.id)
  const isFirst = cardIndex === 0
  const isLast = cardIndex === column.cards.length - 1

  return (
    <div style={{ border: '1px solid #e9ecef', borderRadius: '5px', overflow: 'hidden' }}>
      <div style={{ backgroundColor: '#f8f9fa', padding: window.innerWidth < 768 ? '8px 10px' : '10px 15px', borderBottom: '1px solid #e9ecef' }}>
        <h4 style={{ fontSize: window.innerWidth < 768 ? '15px' : '16px', fontWeight: 600, margin: 0 }}>
          Pozycja na liście
        </h4>
      </div>
      <div style={{ padding: window.innerWidth < 768 ? '10px' : '15px', display: 'flex' }}>
        <button
          onClick={async () => await onChangePosition(card.id, column.id, 'up')}
          disabled={isFirst}
          style={{ flex: 1, padding: '8px', backgroundColor: isFirst ? '#e9ecef' : '#6c757d', color: 'white', border: 'none', borderRadius: '4px 0 0 4px', cursor: isFirst ? 'not-allowed' : 'pointer', fontSize: window.innerWidth < 768 ? '13px' : '14px' }}
        >
          ↑ W górę
        </button>
        <button
          onClick={async () => await onChangePosition(card.id, column.id, 'down')}
          disabled={isLast}
          style={{ flex: 1, padding: '8px', backgroundColor: isLast ? '#e9ecef' : '#6c757d', color: 'white', border: 'none', borderRadius: '0 4px 4px 0', marginLeft: '1px', cursor: isLast ? 'not-allowed' : 'pointer', fontSize: window.innerWidth < 768 ? '13px' : '14px' }}
        >
          ↓ W dół
        </button>
      </div>
    </div>
  )
}
